import React from 'react';
import './Profile.css';
import profileImage from '../../../../images/noor.jpg';
import { Link } from 'react-router-dom';

const Profile = () => {
    return (
        <div className="Profile container py-5">
            <div className="row d-flex justify-content-center align-items-center my-md-5 my-0">
                <div className="col-lg-7 pl-lg-5 pl-2 order-1 order-lg-0 py-4 py-md-5 text-left text-center text-md-left animate__animated animate__fadeInLeft">
                    {/* <p className="hello">Hello! I am</p> */}
                    <h1 className="name"> Noor Muhammad</h1>
                    <h3 className="designation mt-2">Web Developer <span style={{color : 'white'}}>II</span> PROGRAMMER  <span style={{color : 'white'}}>II</span> PROBLEM SOLVER</h3>
                    <div className="social-links my-2">
                        <a href="https://github.com/noor-muhammadd" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
                        <a href="https://www.linkedin.com/in/nur-muhammad-chowdhury-b11742190/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                        <a href="https://medium.com/@nurmuhammadd2001" target="_blank" rel="noopener noreferrer"><i className="fab fa-medium-m"></i></a>
                        <a href="https://www.facebook.com/mdnurmuhammad.chowdhury.7" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                        {/* <a href="https://twitter.com/tayabpabel" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a> */}
                    </div>
                    <p className="description mt-3 mt-md-4 mb-4">I am a Web Developer.Web Developer Specializing in front end development.Experience with all stages of the development cycle for dynamic projects.Strong backgreound in projects management and austomers relations.</p>
                    <a className="btn mr-1" href="https://drive.google.com/u/0/uc?id=1y-BFjh9YqQ0odZy4z_6YYnAvVB2M_eLS&export=download" target="_blank" rel="noopener noreferrer">Get Resume</a>
                    <Link to="/about" className="btn ml-1">About Me</Link>
                </div>
                <div className="col-lg-5 d-flex justify-content-center animate__animated animate__fadeInRight">
                    <img className="img-fluid profile-image" src={profileImage} alt=""/>
                </div>
            </div>
        </div>
    );
};

export default Profile;